import { useSession } from '@/auth/session';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent } from '@/components/ui/card';

export function ProfileCard() {
  const { user, pharmacy } = useSession();
  if (!user) return null;

  return (
    <Card>
      <CardContent className="flex items-center gap-3 py-4">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-grad-primary text-sm font-semibold text-white">
          {user.name.slice(0, 2).toUpperCase()}
        </div>
        <div className="min-w-0 flex-1">
          <p className="truncate font-medium">{user.name}</p>
          <p className="truncate text-xs text-muted-foreground">{user.email}</p>
        </div>
        <Badge variant="secondary">{user.role === 'Superadmin' ? 'Platform admin' : pharmacy?.name ?? user.role}</Badge>
      </CardContent>
    </Card>
  );
}
